import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { MatSelectFilterModule } from 'mat-select-filter';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Observable } from 'rxjs';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { AddRecipientDialogboxComponent } from '../add-recipient-dialogbox/add-recipient-dialogbox.component';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { customValidationService } from 'src/app/shared/custom.validator';

export interface Examinee {
  fullName: string;
  examineeuuid: number;
  examineeId: number;
}


@Component({
  selector: 'app-edit-private-schedule',
  templateUrl: './edit-private-schedule.component.html',
  styleUrls: ['./edit-private-schedule.component.scss']
})
export class EditPrivateScheduleComponent implements OnInit {

  // private schedule form
  privateScheduleForm: FormGroup;

  // date initialization
  minDate: Date;
  minDate1: Date;
  d = new Date();
  timeZoneArr = [];
  zone: any;
  convertStartTime: any;
  minutesToAdd: any;
  setDefaultStartTime: any;
  setDefaultEndTime: any;
  convertEndTime: any;
  selectedExaminees = [];
  dialogBoxData: any;

  // editor initialization
  editor: Editor;
  editor1: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  // mat chip and autocomplete
  public allExaminees: Examinee[] = [];

  // public chipSelectedExaminee: Examinee[] = [];

  public filteredExaminee: Observable<String[]>;

  private allowFreeTextAddExaminee = false;

  public examineeControl = new FormControl();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('examineeInput') examineeInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  setPenaltymsg: boolean;
  setTestScoremsg: boolean;
  isExamineeNotExist = false;
  getMarksDetails: any;
  scheduleInfo: any;
  isLive = false;
  isCompleted = false;
  testuuid: string;
  isStartTimeValid: boolean;
  isEndTimeValid: boolean;
  isFormLoaded = false;

  // search dropdown
  searchOptions = [];
  selected: any;
  filteredList: any;
  timeZoneName: any;
  isAllowAttempts: boolean = false;
  maxAttempts: number = 0;
  weeks: number = 0;
  days: number = 0;
  hours: number = 0;
  constructor(
    private fb: FormBuilder,
    private testService: TestService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    private datePipe: DatePipe, private dialog: MatDialog,
    public rolSer: RoleManagementService,
    public translate: TranslateService,
  ) {
    // /////////////////////////////////////// date logic ////////////////////////////////////////
    // this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    // this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    // //  convert time to current time to plus 30 minute
    // this.convertStartTime = new Date();
    // this.minutesToAdd = new Date(
    //   this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    // );

    // this.setDefaultStartTime =
    //   this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    // this.convertEndTime = this.convertStartTime.setMinutes(
    //   this.convertStartTime.getMinutes() + 60
    // );
    // this.setDefaultEndTime =
    //   this.convertStartTime.getHours() +
    //   ':' +
    //   this.convertStartTime.getMinutes();
    // ////////////////////////////////////////////////////////////////////////////////////////////

    // editor logic
    this.editor = new Editor();
    this.editor1 = new Editor();
  }

  createForm() {
    this.privateScheduleForm = this.fb.group({
      schName: new FormControl({ value: '', disabled: this.isCompleted }, [Validators.required, Validators.minLength(1), Validators.maxLength(120), customValidationService.cannotContainSpace,]),
      schDescription: new FormControl({ value: '', disabled: this.isCompleted }, [Validators.maxLength(480)]),
      startDate: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      startTime: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      endDate: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      endTime: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      timeZone: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      testDuration: new FormControl({ value: '', disabled: this.isCompleted }, [Validators.required]),
      testTotalScore: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      testPassingScore: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      penaltyPoints: new FormControl({ value: '', disabled: this.isCompleted }, Validators.required),
      preMessageText: new FormControl({ value: '', disabled: this.isCompleted }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      postMessageText: new FormControl({ value: '', disabled: this.isCompleted }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      // ExamineeRejoinTest: new FormControl({ value: '', disabled: true }, Validators.required),
      // showResultAfterTest: new FormControl({ value: '', disabled: true }, Validators.required),
      // shuffleItems: new FormControl({ value: '', disabled: true }, Validators.required),
      // shuffleQuestions: new FormControl({ value: '', disabled: true }, Validators.required),
      // shuffleOptions: new FormControl({ value: '', disabled: true }, Validators.required),
      iallquestionsmandatory: new FormControl({ value: '' }),
      MaxAttempts: new FormControl({ value: 1, disabled: this.isCompleted}),
      Weeks: new FormControl({ value: 0, disabled: this.isCompleted}),
      days: new FormControl({ value: 0, disabled: this.isCompleted}),
      hours: new FormControl({ value: 0, disabled: this.isCompleted}),
      showTools: new FormControl({ value: '' }),
      showItemList: new FormControl({ value: '' }),
    });
  }

  counter(i: number) {
    return new Array(i);
  }

  ngOnInit(): void {
    this.testuuid = sessionStorage.getItem('testuuid');
    this.scheduleInfo = JSON.parse(sessionStorage.getItem('scheduleInfo'));
    this.createForm();
    this.testService.editTestSchedule(this.scheduleInfo?.scheduleuuId).subscribe((selectedSchedule) => {
      if (selectedSchedule?.data[0]?.scheduleStatus.includes('Live')) {
        this.isLive = true;
        this.minDate = new Date(selectedSchedule?.data[0]?.startDate);
      }
      else if (selectedSchedule?.data[0]?.scheduleStatus.includes('Completed')) {
        this.isCompleted = true;
      }
      else {
        this.isLive = false;
        this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
      }

      // this.buildPrivateScheduleForm(selectedSchedule.data[0]);

      this.testService.getRecipient(this.scheduleInfo.scheduleuuId, this.testuuid).subscribe(recipientList => {
        const fullInfo = recipientList?.data?.map((value) => (
          { fullName: this.getFnameNemailId(value?.['firstName'], value?.['lastName'], value?.['emailId']), examineeuuid: value?.['examineeuuid'], examineeId: value?.['examineeId'], active: value?.['active'], recipientuuId: value['recipientuuId'] }
        ));
        this.buildPrivateScheduleForm(selectedSchedule.data[0]);
        this.isFormLoaded = true
        this.privateScheduleForm.controls.timeZone.setValue(selectedSchedule.data[0].timeZoneName);
        this.timeZoneName = String(selectedSchedule.data[0].timeZoneName);
        this.selectedExaminees = fullInfo;
        // this.selectedExaminees = recipientList?.data;
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });

    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });

    /////////////////////////////////////// date logic ////////////////////////////////////////

    this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    //  convert time to current time to plus 30 minute
    this.convertStartTime = new Date();
    this.minutesToAdd = new Date(
      this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    );

    this.setDefaultStartTime =
      this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    this.convertEndTime = this.convertStartTime.setMinutes(
      this.convertStartTime.getMinutes() + 60
    );
    this.setDefaultEndTime =
      this.convertStartTime.getHours() +
      ':' +
      this.convertStartTime.getMinutes();
    ////////////////////////////////////////////////////////////////////////////////////////////
    this.getTimeZone();
    this.getPrivateExaminees();
    // this.getMarks();
    // this.filteredExaminee = this.examineeControl.valueChanges.pipe(
    //   map(examineeName => this.filterOnValueChange(examineeName))
    // );
  }

  // form validation
  get f() {
    this.privateScheduleForm.valueChanges.subscribe(valueChange => {
      this.compareDateAndTime(valueChange);
    });
    return this.privateScheduleForm.controls;
  }

  compareDateAndTime(valueChange): any {
    if (valueChange.startTime == '' || valueChange.startTime == '00:00') {
      this.isStartTimeValid = true;
    } else {
      this.isStartTimeValid = false;
    }
    if (valueChange.endTime == '' || valueChange.endTime == '00:00') {
      this.isEndTimeValid = true;
    } else {
      this.isEndTimeValid = false;
    }
  }

  // create private schedule form
  buildPrivateScheduleForm(selectedSchedule) {
    if (this.isCompleted) {
      this.privateScheduleForm.controls.schName.disable();
      this.privateScheduleForm.controls.schDescription.disable();
      this.privateScheduleForm.controls.preMessageText.disable();
      this.privateScheduleForm.controls.postMessageText.disable();
      this.privateScheduleForm.controls.testDuration.disable();
      this.privateScheduleForm.controls.testPassingScore.disable();
      this.privateScheduleForm.controls.testTotalScore.disable();
      this.privateScheduleForm.controls.penaltyPoints.disable();
      this.privateScheduleForm.controls.iallquestionsmandatory.disable();
      this.privateScheduleForm.controls.startDate.disable();
      this.privateScheduleForm.controls.startTime.disable();
      this.privateScheduleForm.controls.endDate.disable();
      this.privateScheduleForm.controls.endTime.disable();
      this.privateScheduleForm.controls.timeZone.disable();
      this.privateScheduleForm.controls.MaxAttempts.disable();
      this.privateScheduleForm.controls.Weeks.disable();
      this.privateScheduleForm.controls.days.disable();
      this.privateScheduleForm.controls.hours.disable();
      this.privateScheduleForm.controls.showTools.disable();
      this.privateScheduleForm.controls.showItemList.disable();
    }

    this.privateScheduleForm.patchValue({
      schName: selectedSchedule?.title.trim(),
      schDescription: selectedSchedule?.description?.trim(),
      startDate: selectedSchedule?.startDate,
      startTime: `${selectedSchedule.startDateHours}:${selectedSchedule.startDateMinutes}`,
      endDate: selectedSchedule?.endDate,
      endTime: `${selectedSchedule.endDateHours}:${selectedSchedule.endDateMinutes}`,
      timeZone: selectedSchedule?.timeZoneName,
      testDuration: selectedSchedule?.testDuration,
      testTotalScore: selectedSchedule?.testScore,
      testPassingScore: selectedSchedule?.testPassingScore,
      penaltyPoints: selectedSchedule?.penaltyPoint,
      preMessageText: selectedSchedule?.preTestMessage?.description?.trim(),
      postMessageText: selectedSchedule?.postTestMessage?.description?.trim(),
      // ExamineeRejoinTest: selectedSchedule?.examineeRejoin,
      // showResultAfterTest: selectedSchedule?.showResultAfterTest,
      // shuffleItems: selectedSchedule?.shuffleItem,
      // shuffleQuestions: selectedSchedule?.shuffleQuestion,
      // shuffleOptions: selectedSchedule?.shuffleOption,
      iallquestionsmandatory: selectedSchedule?.iallquestionsmandatory,
      MaxAttempts: selectedSchedule?.maxNumberOfAttempts,
      Weeks: selectedSchedule?.allowReattemptAfterWeeks,
      days: selectedSchedule?.allowReattemptAfterDays,
      hours: selectedSchedule?.allowReattemptAfterHours,
      showTools: selectedSchedule?.showTools,
      showItemList: selectedSchedule?.showItemList,
    });

    this.maxAttempts = selectedSchedule?.maxNumberOfAttempts;
    this.weeks = selectedSchedule?.allowReattemptAfterWeeks;
    this.days = selectedSchedule?.allowReattemptAfterDays;
    this.hours = selectedSchedule?.allowReattemptAfterHours;

    if (this.maxAttempts > 0) this.isAllowAttempts = true;
  }

  // merge fname and emailid
  getFnameNemailId(firstName, lastName, emailId) {
    if (firstName === undefined) {
      firstName = '';
    }
    if (lastName === undefined) {
      lastName = '';
    }
    if (emailId === undefined) {
      emailId = '';
    }
    return `${firstName} ${lastName} (${emailId})`;
  }


  /////////////////////////////////////// start add and remove recipient logic //////////////////////////////////////////////
  // // add new chip
  // public addExaminee(event: MatChipInputEvent): void {
  //   if (!this.allowFreeTextAddExaminee) {
  //     // only allowed to select from the filtered autocomplete list
  //     return;
  //   }

  //   //
  //   // Only add when MatAutocomplete is not open
  //   // To make sure this does not conflict with OptionSelected Event
  //   //
  //   if (this.matAutocomplete.isOpen) {
  //     return;
  //   }

  //   // Add our examinee
  //   const value = event.value;
  //   if ((value || '').trim()) {
  //     this.selectExamineeByName(value.trim());
  //   }

  //   this.resetInputs();
  // }

  // // remove chip
  // public removeExaminee(examinee: Examinee): void {
  //   const index = this.chipSelectedExaminee.indexOf(examinee);
  //   if (index >= 0) {
  //     this.chipSelectedExaminee.splice(index, 1);
  //     if (this.chipSelectedExaminee.length === 0) {
  //       this.isExamineeNotExist = true;
  //       return;
  //     }
  //     this.resetInputs();
  //   }
  // }

  // // selected examinee
  // public selectedExaminee(event: MatAutocompleteSelectedEvent): void {
  //   this.selectExamineeByName(event.option.value);
  //   this.resetInputs();
  // }

  // // reset add recipient input box
  // private resetInputs() {
  //   // clear input element
  //   this.examineeInput.nativeElement.value = '';
  //   // clear control value and trigger examineeControl.valueChanges event
  //   this.examineeControl.setValue(null);
  // }

  // // filter add recipient input box on change value
  // private filterOnValueChange(examineeName: string | null): String[] {
  //   let result: String[] = [];
  //   //
  //   // Remove the examinees we have already selected from all examinees to
  //   // get a starting point for the autocomplete list.
  //   //
  //   let allExamineesLessSelected = this.allExaminees.filter(examinee => this.chipSelectedExaminee.indexOf(examinee) < 0);
  //   if (examineeName) {
  //     result = this.filterExaminee(allExamineesLessSelected, examineeName);
  //   } else {
  //     result = allExamineesLessSelected.map(examinee => examinee.fullName);
  //   }
  //   return result;
  // }

  // // filter examinee after detect any change
  // private filterExaminee(examineeList: Examinee[], examineeName: String): String[] {
  //   let filteredExamineeList: Examinee[] = [];
  //   const filterValue = examineeName.toLowerCase();
  //   let examineesMatchingEngineerName = examineeList.filter(examinee => examinee.fullName.toLowerCase().indexOf(filterValue) === 0);
  //   if (examineesMatchingEngineerName.length || this.allowFreeTextAddExaminee) {
  //     //
  //     // either the examinee name matched some autocomplete options
  //     // or the name didn't match but we're allowing
  //     // non-autocomplete examinee names to be entered
  //     //
  //     filteredExamineeList = examineesMatchingEngineerName;
  //   } else {
  //     //
  //     // the examinee name didn't match the autocomplete list
  //     // and we're only allowing examinees to be selected from the list
  //     // so we show the whjole list
  //     //
  //     filteredExamineeList = examineeList;
  //   }
  //   //
  //   // Convert filtered list of examinee objects to list of examinee
  //   // name strings and return it
  //   //
  //   return filteredExamineeList.map(examinee => examinee.fullName);
  // }


  // private selectExamineeByName(examineeName) {
  //   let foundExaminee = this.allExaminees.filter(examinee => examinee.fullName == examineeName);
  //   if (foundExaminee.length) {
  //     //
  //     // We found the examinee name in the allExaminees list
  //     //
  //     this.chipSelectedExaminee.push(foundExaminee[0]);
  //     if (this.chipSelectedExaminee.length > 0) {
  //       this.isExamineeNotExist = false;
  //       return;
  //     }
  //   }
  // }

  /////////////////////////////////////// end add and remove recipient logic //////////////////////////////////////////////

  ////////////////////////////////////// not used anywhere in html /////////////////////////////////////////////////////////
  testScoreChange() {
    if (
      this.privateScheduleForm?.value?.testPassingScore + 1 >
      // this.scheduleForm.controls['testPassingScore'].value || this.scheduleForm.controls['penaltyPoint'].value >
      this.privateScheduleForm?.value?.testTotalScore
    ) {

      this.setTestScoremsg = true;
      setTimeout(() => {
        this.setTestScoremsg = false;
      }, 1000);
      // this.privateScheduleForm.value.testPassingScore.patchValue({ testPassingScore: '0' });
    } else {
      this.setTestScoremsg = false;
    }

  }


  checkTestValue() {
    if (
      this.privateScheduleForm.value.penaltyPoints + 1 >
      this.privateScheduleForm?.value?.testTotalScore
    ) {
      this.setPenaltymsg = true;
      // this.privateScheduleForm.patchValue({ penaltyPoints: '0' });
    } else {
      this.setPenaltymsg = false;
    }

  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  // get all time zones
  getTimeZone(): void {
    this.testService.getTimeZone().subscribe((timezonedata) => {
      this.timeZoneArr = timezonedata?.data;

      // Dropdown Search filter
      this.searchOptions = this.timeZoneArr;
      this.selected = this.searchOptions[0]?.name;
      this.filteredList = this.searchOptions.slice();

    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get all existing private examinees
  getPrivateExaminees(): void {
    this.testService.getExamineetoSchedule().subscribe((resData) => {

      const fullInfo = resData.items.map((value) => (
        { fullName: this.getFnameNemailId(value['firstName'], value['lastName'], value['emailId']), examineeuuid: value['examineeuuid'], examineeId: value['examineeId'] }
      ));
      this.allExaminees = fullInfo;
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get marks
  getMarks(): void {
    const marks = this.testService.getTestToltalScore(this.testuuid).subscribe((resData) => {
      this.privateScheduleForm.patchValue({
        testTotalScore: resData?.data?.totalMarks, testPassingScore: resData?.data?.passingCriteria, testDuration: resData?.data?.duration
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // navigate to back
  back() {
    this.testService.scheduleBackBtnobs.next(false);
  }

  // open add recipient dialog box
  addRecipientDialogbox(): void {
    this.isExamineeNotExist = false;
    this.testService.getExamineetoSchedule().subscribe((resData) => {
      this.dialogBoxData = resData?.items;
      this.dialogBoxData.forEach(tableElement => {
        tableElement['checked'] = false;
      });

      this.selectedExaminees?.forEach(element => {
        let b = this.dialogBoxData.findIndex((x) => x.examineeId === element?.examineeId);
        this.dialogBoxData[b].checked = true;
      })

      const dialogRef = this.dialog.open(AddRecipientDialogboxComponent, {
        // disableClose: false,
        width: '1000px',
        panelClass: 'add-recipient-container',
        data: this.dialogBoxData,
      });

      dialogRef.afterClosed().subscribe(result => {
        const fullInfo = result.map((value) => (
          { fullName: this.getFnameNemailId(value['firstName'], value['lastName'], value['emailId']), examineeuuid: value['examineeuuid'], examineeId: value['examineeId'], active: value['active'] }
        ));
        this.selectedExaminees = fullInfo;
        // this.chipSelectedExaminee = this.selectedExaminees;
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // remove examinee from list
  removeExamineeFromArray(chip) {
    this.selectedExaminees = this.selectedExaminees.filter(value => value?.examineeId !== chip?.examineeId);
    if (this.selectedExaminees.length === 0) {
      this.isExamineeNotExist = true;
    }
    // this.chipSelectedExaminee = this.selectedExaminees;
  }


  // submit private schedule form
  onSubmit(form) {
    if (this.selectedExaminees?.length < 0) {
      this.isExamineeNotExist = true;
      return;
    }

    // if (form.value.testPassingScore > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Passing Score can not be greater than test score', true, 'warn')
    //   return;
    // }

    // if (form.value.penaltyPoints > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Penalty points can not be greater than test score', true, 'warn')
    //   return;
    // }

    let newDate: Date = new Date();
    let schEndDate = this.privateScheduleForm.value.startDate;

    if (parseInt(form.value?.Weeks) > 0) newDate.setDate(schEndDate.getDate() + parseInt(form.value?.Weeks) * 7);
    if (parseInt(form.value?.days) > 0) newDate.setDate(newDate.getDate() + parseInt(form.value?.days))
    if (parseInt(form.value?.hours) > 0) {
      // let startTime = this.publicScheduleForm.value.startTime;
      // newDate.setHours(startTime + parseInt(form.value?.hours))
    }

    if (parseInt(form.value?.Weeks) > 0 || parseInt(form.value?.days) > 0 || parseInt(form.value?.hours) > 0) {
      if (((this.datePipe.transform(this.privateScheduleForm.value.endDate, 'yyyy-MM-dd')) < this.datePipe.transform(newDate, 'yyyy-MM-dd'))
         ) {
        this.webErrorService.customErrors(this.translate.instant('test.editSchedule.public.AttemptError'), true, 'warn');
        return;
      }
      // console.log(this.publicScheduleForm.value.endTime)
      // console.log(newDate.getHours() + ':'+ newDate.getMinutes())
      // if (((this.datePipe.transform(this.publicScheduleForm.value.endDate, 'yyyy-MM-dd')) <= this.datePipe.transform(newDate, 'yyyy-MM-dd') &&
      // this.publicScheduleForm.value.endTime < (newDate.getHours() + ':'+ newDate.getMinutes()))) {
      //   alert('Please select schedule time');
      // }
    }

    const finalPayload = this.getFinalPayload(form);
    this.testService.editTestScheduleForm(finalPayload).subscribe((resData) => {
      if (resData.success) {
        this.notificationService.success(resData?.message);
        this.back();
      }
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    });
  }

  // schedule cancelled or delete
  cancelTestSchedule() {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('test.editSchedule.private.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('test.editSchedule.private.deletePopup.btnYes'),
          cancel: this.translate.instant('test.editSchedule.private.deletePopup.btnNo'),
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.testService.cancleSchduel(this.scheduleInfo?.scheduleuuId).subscribe(
          (deldata) => {
            this.notificationService.success(deldata?.message); // this line used to display error message
            this.back();
          },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
      }
    });
  }


  // construct api payload
  getFinalPayload(payload): any {
    const examinneIds = this.selectedExaminees.map((value) => value.examineeId);
    return payload = {
      examinees: examinneIds,
      publicScheduleParameters: {
        parameters: []
      },
      clientuuId: JSON.parse(sessionStorage?.getItem('currentUser'))?.clientuuId,
      collectionId: sessionStorage.getItem('defaultcollectionid'),
      description: payload?.value?.schDescription?.trim() || null,
      endDate: this.datePipe.transform(payload.value.endDate, 'yyyy-MM-dd'),
      endDateHours: payload.value.endTime.split(':')[0],
      endDateMinutes: payload.value.endTime.split(':')[1],
      postTestMessage: {
        description: payload?.value?.postMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      preTestMessage: {
        description: payload?.value?.preMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      iallquestionsmandatory: payload?.value?.iallquestionsmandatory,
      scheduleStatus: this.scheduleInfo.scheduleStatus,
      scheduleType: this.scheduleInfo?.scheduleType,
      scheduleuuId: this.scheduleInfo?.scheduleuuId,
      testScheduleId: this.scheduleInfo?.testScheduleId,
      startDate: this.datePipe.transform(payload.value.startDate, 'yyyy-MM-dd'),
      startDateHours: payload.value.startTime.split(':')[0],
      startDateMinutes: payload.value.startTime.split(':')[1],
      testBankId: sessionStorage.getItem('testBankId'),
      testDuration: payload?.value?.testDuration,
      testPassingScore: JSON.parse(payload?.value?.testPassingScore),
      testScore: JSON.parse(payload?.value?.testTotalScore),
      penaltyPoint: payload?.value?.penaltyPoints,
      timeZoneName: this.timeZoneName,  //payload?.value?.timeZone,
      title: payload.value.schName?.trim(),
      maxnumberofattempts: parseInt(payload?.value?.MaxAttempts),
      allowreattemptafterweeks: payload?.value?.MaxAttempts == 0 ? payload?.value?.Weeks.value : payload?.value?.Weeks,
      allowreattemptafterdays: payload?.value?.MaxAttempts == 0 ? payload?.value?.days.value : payload?.value?.days,
      allowreattemptafterhours: payload?.value?.MaxAttempts == 0 ? payload?.value?.hours.value : payload?.value?.hours,
      showtools: payload?.value?.showTools,
      showitemlist: payload?.value?.showItemList
    }
  }

  onSelectMaxAttempts(event) {
    console.log(event.target.value);
    if (event.target.value != 0) {
      this.isAllowAttempts = true;
    } else {
      this.privateScheduleForm.value.Weeks = 0;
      this.privateScheduleForm.value.days = 0;
      this.privateScheduleForm.value.hours = 0;
      this.weeks = 0;
      this.days = 0;
      this.hours = 0;
      this.isAllowAttempts = false;
    }
  }

}

@NgModule({
  declarations: [
    EditPrivateScheduleComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    NgxEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatSelectFilterModule,
    TranslateModule
  ]
})
class EditPrivateScheduleComponentModule {

}
